import { format } from 'date-fns';
import type { Offer } from '../../api/viewOfferApiService';

export interface ViewOfferContentProps {
  activeTabId: string;
  offer: Offer;
}

const ViewOfferContent = ({ activeTabId, offer }: ViewOfferContentProps) => {
  if (activeTabId === 'EdytujOferte') {
    return (
      <div className="flex flex-col gap-6 m-[6px]">
        <div className="flex flex-col gap-4 border-2 border-[#DCDDE0] rounded-[8px] p-4">
          <p
            className="text-[18px] font-medium text-on-surface-variant"
            aria-label="Szczegóły planu"
            data-testid="plan-details-title"
          >
            Szczegóły oferty
          </p>
          <div className="flex flex-col gap-8">
            <div className="flex flex-col min-w-0 gap-2">
              <h2
                className="font-normal text-bodySmall text-on-surface-variant"
                data-testid="Szczegóły oferty"
              >
                Szczegóły oferty
              </h2>
              <p
                className="min-w-0 font-normal break-words align-middle text-bodyLarge text-neutral-10"
                data-testid="Szczegóły oferty-value"
              >
                {offer.id ?? offer.offerName ?? '—'}
              </p>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-col min-w-0 gap-2">
                <h2
                  className="font-normal text-bodySmall text-on-surface-variant"
                  data-testid="Plan subskrypcji"
                >
                  Plan subskrypcji
                </h2>
                <div
                  className="flex flex-wrap gap-2"
                  data-testid="Plan subskrypcji-value"
                >
                  {offer.subscriptionPlans &&
                  offer.subscriptionPlans.length > 0 ? (
                    offer.subscriptionPlans.map((plan) => (
                      <p
                        key={plan.id}
                        className="inline-flex w-fit items-center justify-center
        text-bodyLarge font-normal wrap-anywhere
        text-[#1665C2] bg-[#F0F9FF]
        rounded-[8px] px-2 py-1"
                      >
                        {plan.name}
                      </p>
                    ))
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Pricing & Billing Tab
  else {
    return (
      <div className="flex flex-col gap-6 m-[6px]">
        {/* Duration & Billing Section */}
        <div className="flex flex-col gap-4 border-2 border-[#DCDDE0] rounded-[8px] p-4">
          <p
            className="text-[18px] font-medium text-on-surface-variant"
            aria-label="Okres i rozliczenia"
            data-testid="duration-billing-title"
          >
            Konfiguracja oferty
          </p>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col min-w-0 gap-2">
              <h2
                className="font-normal text-bodySmall text-on-surface-variant"
                data-testid="Typ okresu"
              >
                {`Wartość rabatu (${offer.discountType === 'PERCENTAGE' ? 'Procentowy' : 'Stały'})`}
              </h2>
              <p
                className="min-w-0 font-normal break-words align-middle text-bodyLarge text-neutral-10"
                data-testid="Typ okresu-value"
              >
                {offer.discountValue ?? '—'}
                {offer.discountType === 'PERCENTAGE' ? '%' : ''}
              </p>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="flex flex-col gap-4 border-2 border-[#DCDDE0] rounded-[8px] p-4">
          <p
            className="text-[18px] font-medium text-on-surface-variant"
            aria-label="Cennik"
            data-testid="pricing-title"
          >
            Okres obowiązywania
          </p>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col min-w-0 gap-2">
              <h2
                className="font-normal text-bodySmall text-on-surface-variant"
                data-testid="Zakres dat"
              >
                Zakres dat
              </h2>
              <div
                className="flex items-center gap-1"
                data-testid="Zakres dat-value"
              >
                <p
                  className="min-w-0 break-words text-labelLarge text-[#223746] py-[6px] px-3 align-middle bg-[#F2F4F5] rounded-[8px]"
                  data-testid="Zakres dat-value-start"
                >
                  {offer.validityPeriod?.startDate
                    ? format(
                        new Date(offer.validityPeriod.startDate),
                        'yyyy/MM/dd'
                      )
                    : '—'}
                </p>
                <p data-testid="Zakres dat-value-separator">{'-'}</p>
                <p
                  className="min-w-0 break-words text-labelLarge text-[#223746] py-[6px] px-3 align-middle bg-[#F2F4F5] rounded-[8px]"
                  data-testid="Zakres dat-value-end"
                >
                  {offer.validityPeriod?.endDate
                    ? format(
                        new Date(offer.validityPeriod.endDate),
                        'yyyy/MM/dd'
                      )
                    : '—'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default ViewOfferContent;
